<template>
  <page-list
    :list="list"
    :columns="changedColumns"
    :group-actions="groupActions"
    :single-actions="changedSingleActions"
    :export-data-options="exportDataOptions"
    :placeholder="$t('common.default_search_key', [$t('bill.product_type')])"
    defaultSearchKey="product_type" />
</template>

<script>
import * as R from 'ramda'
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'
import { getDistinctFieldFilter, getNameFilter } from '@/utils/common/tableFilter'
import { HYPERVISORS } from '@/constants'
import ColumnsMixin from '../mixins/columns'
import SingleActionsMixin from '../mixins/singleActions'

export default {
  name: 'BillProductList',
  mixins: [WindowsMixin, ListMixin, ColumnsMixin, SingleActionsMixin],
  props: {
    id: String,
    cloudEnv: {
      type: String,
    },
    getParams: {
      type: [Object, Function],
    },
  },
  data () {
    const filterOptions = {
      provider: getDistinctFieldFilter({
        field: 'provider',
        label: this.$t('table.title.brand'),
        mapper: (list) => {
          return list.map(item => {
            const target = HYPERVISORS.filter(l => l.provider === item.key)
            return {
              key: item.key,
              label: target.length ? target[0].label : item.key,
            }
          })
        },
      }),
      origin_res_type: getDistinctFieldFilter({
        field: 'origin_res_type',
        label: this.$t('bill.origin_res_type'),
      }),
      product_type: getNameFilter({ field: 'product_type', label: this.$t('bill.product_type') }),
      origin_usage_type: getDistinctFieldFilter({
        field: 'origin_usage_type',
        label: this.$t('bill.origin_usage_type'),
      }),
    }
    return {
      filterOptions,
      list: this.$list.createList(this, {
        id: this.id,
        resource: 'bill_products',
        apiVersion: 'v1',
        getParams: this.getParam,
        filterOptions: this.cloudEnv === 'dictionary' ? { product_type: filterOptions.product_type } : { ...filterOptions },
      }),
    }
  },
  computed: {
    exportDataOptions () {
      return {
        title: this.cloudEnv === 'dictionary' ? this.$t('bill.dictionary_maintenance') : this.$t('bill.mapping_maintenance'),
        items: this.changedColumns,
        downloadType: 'local',
      }
    },
    changedColumns () {
      return this.columns.filter(column => {
        return this.cloudEnv === 'dictionary' ? column.field === 'product_type' : column.field !== 'product_type'
      })
    },
    changedSingleActions () {
      return this.singleActions.filter(action => {
        return this.cloudEnv === action.type
      })
    },
    groupActions () {
      return this.cloudEnv === 'dictionary' ? [] : [
        {
          label: this.$t('bill.batch_update_mapping'),
          action: () => {
            this.createDialog('BillProductUpdateDialog', {
              data: this.list.selectedItems,
              ok: () => {
                this.list.fetchData()
              },
            })
          },
          meta: () => ({
            validate: this.list.selectedItems.length,
          }),
        },
      ]
    },
  },
  watch: {
    cloudEnv (val) { // 这里指 虚拟资源费率、裸金属服务器费率、GPU卡费率
      this.fetchData()
      this.list.filterOptions = this.cloudEnv === 'dictionary' ? { product_type: this.filterOptions.product_type } : { ...this.filterOptions }
    },
  },
  created () {
    this.fetchData()
  },
  methods: {
    getParam () {
      const getParams = (R.is(Function, this.getParams) ? this.getParams() : this.getParams)
      const ret = {
        details: true,
        admin: this.$store.getters.isAdminMode,
        ...getParams,
      }
      if (this.cloudEnv === 'dictionary') {
        ret.group_by = 'product_type'
      }
      return ret
    },
    fetchData () {
      this.list.fetchData()
    },
    handleOpenSidepage (row) {
      this.sidePageTriggerHandle(this, 'BillProductSidePage', {
        id: row.id,
        resource: () => {
          return {
            data: row,
          }
        },
        type: this.cloudEnv,
        data: row,
      }, {
        list: this.list,
      })
    },
  },
}
</script>
